<script>
import GameCard from './GameCard.vue';
import { mergeData } from 'vue-functional-data-merge';
export default {
  functional: true,
  render (h, ctx) {
    const { props, children, data } = ctx;
    const $store = ctx.parent.$store;
    return h('launcher-router-link', {
      props: {
        to: { name: 'games-show', params: { stationId: $store.state.route.params.stationId, gameId: props.game.id } },
      },
      key: data.key,
    }, [h(GameCard, mergeData(data, { props }), children)]);
  },
};
</script>
